export default __webpack_public_path__ + "static/media/popup_background.5e716965.png";